<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Update Details"
            bc1="App"
            bc2="Admin"
            bc3="Update"
            path="admin-users"
          ></Breadcrumb>
        </div>
        <div
          class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
          <div class="form-group breadcrumb-right">
            <div class="dropdown">
              <button
                class="btn-icon btn btn-primary btn-round btn-sm dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <CommandIcon />
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <a class="dropdown-item" href="app-todo.html"
                  ><i class="mr-1" data-feather="check-square"></i
                  ><span class="align-middle">Todo</span></a
                ><a class="dropdown-item" href="app-chat.html"
                  ><i class="mr-1" data-feather="message-square"></i
                  ><span class="align-middle">Chat</span></a
                ><a class="dropdown-item" href="app-email.html"
                  ><i class="mr-1" data-feather="mail"></i
                  ><span class="align-middle">Email</span></a
                ><a class="dropdown-item" href="app-calendar.html"
                  ><i class="mr-1" data-feather="calendar"></i
                  ><span class="align-middle">Calendar</span></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><i class="far fa-user"></i
                                ></span>
                              </div>
                              <input
                                type="text"
                                v-model="name"
                                id="name-icon"
                                class="form-control"
                                readonly
                                :class="
                                  errorBag.has('name') ? 'is-invalid' : ''
                                "
                                name="name"
                                placeholder="Name"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('name')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("name") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Status Reason</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="statusReason"
                                class="form-control"
                                :class="
                                  errorBag.has('statusReason')
                                    ? 'is-invalid'
                                    : ''
                                "
                                name="statusReason"
                                placeholder="Status Reason"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('statusReason')"
                                class="invalid-feedback"
                                >{{
                                  "*" + errorBag.first("statusReason")
                                }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Roles</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <multiselect
                                v-model="selectedRoles"
                                :options="rolesOption"
                                label="label"
                                track-by="value"
                                multiple
                                variant="primary"
                              ></multiselect>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-9 offset-sm-3 text-right mt-2 d-flex">
                      <button
                        type="button"
                        class="btn btn-primary mr-1 d-flex"
                        @click="sendCall"
                        :disabled="loading"
                      >
                        <Loader :loading="loading" :size="size"></Loader>
                        Save
                      </button>
                      <button
                        type="button"
                        class="btn btn-gradient-secondary"
                        @click="Back()"
                      >
                        Back
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";

export default {
  components: {
    CommandIcon
  },
  data() {
    return {
      id: "",
      index: "",
      name: "",
      statusReason: "",
      loading: false,
      size: "10px",
      rolesOption: [],
      selectedRoles:[]
    };
  },
  mounted() {
    let userUpdateData = this.$store.getters.getByKey("adminUserUpdate");
    if (userUpdateData) {
        console.log('userUpdateData', userUpdateData);
      this.index = userUpdateData.index;
      this.id = userUpdateData.row.id;
      this.name = userUpdateData.row.first_name;
    }
  },
  methods: {
    Back() {
      this.$router.push({ name: "admin-user" });
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = new FormData();
          data.append("application", "android");
          data.append("applicationVersion", "1.33");
          data.append("deviceId", "XXXXXXXXXXXXXXXXXXXXXXXX");
          data.append("deviceDetail", "android s4 etc");
          data.append("latitude", "");
          data.append("longitude", "");
          data.append("userId", this.id);

          this.makeRequest("post", "v1/update-user-status", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey("AdminUser");
                    if (storeData != null) {
                      if (typeof storeData.firstPageData != "undefined") {
                        if (
                          typeof storeData.firstPageData.data[this.index] !=
                          "undefined"
                        ) {
                          if (
                            storeData.firstPageData.data[this.index].id ==
                            this.id
                          ) {
                            storeData.firstPageData.data[
                              this.index
                            ] = responseData;
                            delete storeData.otherPageData;
                          }
                        }
                      }
                      if (typeof storeData.otherPageData != "undefined") {
                        if (
                          typeof storeData.otherPageData.data[this.index] !=
                          "undefined"
                        ) {
                          if (
                            storeData.otherPageData.data[this.index].id ==
                            this.id
                          ) {
                            storeData.otherPageData.data[
                              this.index
                            ] = responseData;
                          }
                        }
                      }
                      storeData.key = "AdminUser";
                      this.$store.dispatch("set", storeData);
                    }
                    this.$router.push({
                      name: "admin-user",
                      params: { update: true }
                    });
                  }
                } else {
                  this.loading = false;
                }
              }
            }
          );
        }
      });
    }
  }
};
</script>

